import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'services/_infra/rtkBaseQuery';

export const globalActionsApi = createApi({
  reducerPath: 'globalActionsApi', // This is the name of the slice in the store
  baseQuery: axiosBaseQuery(), // Custom axios base query (calls apiClient with the query url and params)
  tagTypes: ['Global Actions'], // Used to track when refetches are needed
  endpoints: (builder) => ({
    getGlobalActions: builder.query({
      query: () => ({
        url: '/v2/global-action',
      }),
      transformResponse: (response) => response.result,
      providesTags: ['Global Actions'], // Tells RTK Query this query provides 'Global Actions' data and to refetch when invalidated
    }),
    setGlobalActionEnabled: builder.mutation({
      query: ({ id, status }) => ({
        url: `/v2/global-action/${id}/enabled`,
        method: 'PATCH',
        data: { enabled: status },
      }),
      invalidatesTags: ['Global Actions'], // Tells RTK Query this mutation invalidates 'Global Actions' data and triggers a refetch
    }),
    deleteGlobalAction: builder.mutation({
      query: (globalActionId) => ({
        url: `/v2/global-action/${globalActionId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Global Actions'], // Tells RTK Query this mutation invalidates 'Global Actions' data and triggers a refetch
    }),
    insertGlobalAction: builder.mutation({
      query: (globalAction) => ({
        url: '/v2/global-action',
        method: 'POST',
        data: { globalAction },
      }),
      invalidatesTags: ['Global Actions'], // Tells RTK Query this mutation invalidates 'Global Actions' data and triggers a refetch
    }),
    updateGlobalAction: builder.mutation({
      query: ({ id, action }) => ({
        url: `/v2/global-action/${id}`,
        method: 'PUT',
        data: { globalAction: action },
      }),
      invalidatesTags: ['Global Actions'], // Tells RTK Query this mutation invalidates 'Global Actions' data and triggers a refetch
    }),
    lockGlobalAction: builder.mutation({
      query: (id) => ({
        url: `/v2/global-action/${id}/lock`,
        method: 'POST',
      }),
      invalidatesTags: ['Global Actions'],
    }),
    unlockGlobalAction: builder.mutation({
      query: (id) => ({
        url: `/v2/global-action/${id}/lock`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Global Actions'],
    }),
  }),
});

export const {
  useGetGlobalActionsQuery,
  useSetGlobalActionEnabledMutation,
  useDeleteGlobalActionMutation,
  useInsertGlobalActionMutation,
  useUpdateGlobalActionMutation,
  useLockGlobalActionMutation,
  useUnlockGlobalActionMutation,
} = globalActionsApi;
